export default "__VITE_ASSET__CaSJtdbD__"